import type { AppDetail } from "@biteasy/contracts";
import { AlertBar } from "@/components/AlertBar";
import { useZodServerError } from "@/hooks/use-zod-server-error";
import { useAutosaveSection } from "../hooks/use-auto-save";

export function Alerts({
	app,
	setTab,
}: {
	app: AppDetail;
	setTab: (tab: string) => void;
}) {
	const { setZodServerError } = useZodServerError();

	const disableTestMode = useAutosaveSection<boolean>({
		initialValue: app?.testMode ?? false,
		buildPayload: () => ({ id: app.id, testMode: false }),
		onError: setZodServerError,
	});

	return (
		<>
			{!app.billingEntityId && (
				<AlertBar
					variant="default"
					title="Set up billing"
					action={
						<button
							type="button"
							className="btn btn-sm btn-primary text-primary-content border-none"
							onClick={() => setTab("settings")}
						>
							Set Up Now
						</button>
					}
				>
					Attach a payment method to enable partner payouts.
				</AlertBar>
			)}
			{app.computed?.hasPayableLinks &&
				(!app.iapConfigs ||
					(Array.isArray(app.iapConfigs) && app.iapConfigs.length === 0)) && (
					<AlertBar
						variant="warning"
						title="Revenue tracking not configured"
						action={
							<button
								type="button"
								className="btn btn-sm btn-white text-warning border-none"
								onClick={() => setTab("settings")}
							>
								Configure
							</button>
						}
					>
						This app has referral links with payouts enabled but no payment
						processing (IAP webhooks) set up. Partner earnings cannot be tracked
						until this is configured.
					</AlertBar>
				)}
			{app.testMode && (
				<AlertBar
					variant="warning"
					title="Test Mode"
					action={
						<button
							type="button"
							className="btn btn-sm btn-white text-warning border-none"
							onClick={() => disableTestMode.update(false)}
						>
							Disable
						</button>
					}
				>
					Test mode is enabled. This will simulate flows and test your app. No
					real transactions will be processed.
				</AlertBar>
			)}
		</>
	);
}
